module.exports = __webpack_public_path__ + "img/asesoramoscliente.698c5edf.png";